export {InputPasswordModule} from './input-password.module';
export * from './input-password.component';
